<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-col class="left-container">
    <Header />
    <List
      :selected="props.selected"
      :roles="props.roles"
      @selected-role-changed="handleSelectedRoleChanged($event)"
    />
  </v-col>
</template>
<script setup lang="ts">
import Header from './components/Header/Header.vue';
import List from './components/List/List.vue';

const props = defineProps({
  selected: {
    type: Object,
    default: () => ({})
  },
  roles: {
    type: Array,
    default: () => ([])
  }
});

const emit = defineEmits(['selected-role-changed']);
function handleSelectedRoleChanged(event: any) {
  emit('selected-role-changed', event);
}

</script>
<style lang="scss" scoped>
@import './styles/left.scss';
</style>
